/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIStoragePositionRequest
 */
export interface APIStoragePositionRequest {
    /**
     * 
     * @type {string}
     * @memberof APIStoragePositionRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIStoragePositionRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the APIStoragePositionRequest interface.
 */
export function instanceOfAPIStoragePositionRequest(value: object): value is APIStoragePositionRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIStoragePositionRequestFromJSON(json: any): APIStoragePositionRequest {
    return APIStoragePositionRequestFromJSONTyped(json, false);
}

export function APIStoragePositionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIStoragePositionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function APIStoragePositionRequestToJSON(value?: APIStoragePositionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'comment': value['comment'],
    };
}

